import * as React from 'react';
import {cardArtUrl, isCardProductId} from 'src/cardProductOptions';

type Props = {
  /** Card product slug, e.g. "amex_platinum". Unknown or empty renders nothing. */
  product: string | null | undefined;
  /**
   * Tailwind width class (e.g. "w-9"); height follows from the card aspect
   * ratio so every face sits in the same box regardless of source pixels.
   */
  className?: string;
  alt?: string;
};

/**
 * A card face at credit-card proportions (1.586:1). Faces in
 * frontend/static/cards/ are full-bleed artwork drawn to a hard rectangle —
 * none carry rounded transparent corners — so the face is rendered square
 * and its own artwork defines the edge.
 */
export const CardArt = ({product, className = 'w-9', alt = ''}: Props) => {
  if (!isCardProductId(product)) return null;
  return (
    <img
      src={cardArtUrl(product)}
      alt={alt}
      loading="lazy"
      // Square corners: every committed face is a hard rectangle with its
      // own artwork running to the edge, so rounding it clips the art rather
      // than following it. The faint ring keeps a dark face from dissolving
      // into a dark surface and a silver one from floating on white.
      className={`${className} ring-foreground/10 aspect-[1.586] shrink-0 object-cover ring-1`}
    />
  );
};
